import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class DataMappingsApi {
  static getDataMappingsForUpload = () => {
    return axios.get(API_BASE_URL + '/data-mappings/for-upload');
  };

  static getDataMapping = (id) => {
    return axios.get(`${API_BASE_URL}/data-mapping-groups/${id}`);
  };

  static updateBankAccountLinkage = (dataMappingId, clientBankAccountId) => {
    return axios.put(
      `${API_BASE_URL}/data-mapping-groups/${dataMappingId}/client-bank-account`,
      { client_bank_account_id: clientBankAccountId },
    );
  };

  static getAudienceDesignatorOptions = () => {
    return axios.get(
      `${API_BASE_URL}/data-mappings/audience-designator-options`,
    );
  };

  static getDataMappingsForFilters = (role) => {
    return axios.get(
      API_BASE_URL +
        '/data-mappings/for-filters' +
        (role === 'admin' ? '-admin' : ''),
    );
  };

  static previewTransforms = (payload, config = {}) => {
    return axios.post(
      `${API_BASE_URL}/data-mappings/preview-transforms`,
      payload,
      { skipToast: true, ...config },
    );
  };
}
